import { render, staticRenderFns } from "./VAppLocale.vue?vue&type=template&id=afe95d0e&scoped=true&"
import script from "./VAppLocale.vue?vue&type=script&lang=js&"
export * from "./VAppLocale.vue?vue&type=script&lang=js&"
import style0 from "./VAppLocale.vue?vue&type=style&index=0&id=afe95d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe95d0e",
  null
  
)

export default component.exports